module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/stretchlab-fa2048098a4152a26c00011ba77be60a.png";